import { create } from 'zustand';
import { devtools } from "zustand/middleware";
import type { ICheckoutCustomizationData } from '../types/innerLayout/checkout_customization';
import type { ICheckoutCustomizationStore } from '../types/zustand/checkout-customization';

export const INITIAL_STATE: ICheckoutCustomizationData = {
  branding: {
    brand_name: "",

    checkout_address: "",
    checkout_city: "",
    selectedCountryCode: "",
    checkout_selected_countery: undefined,
    checkout_phone_number: "",

    colors: {
      accent: "",
      action: ""
    },

    font: {
      label: "",
      value: ""
    },

    style: {
      label: "",
      value: ""
    }
  },
  payments: {
    layout: "tab",
    pay_later: false,

    methods: [],
    bnpl: [],
    x_pay: [],

    toggles: {
      display_billing: false,
      display_shipping: false,
      display_items: false,
      display_savecard: false,
      enable_instant_refund: false,

      allow_payments_retries: false,
      allow_payment_cancellation: false
    },

    split_payment: {
      enabled: false,
      max_allowed_cards: 0
    },

    showTerms: false,
    termsUrl: "",
  },
  post_payment: {
    useCustomMessage: false,
    message: "",
    mode: "AUTO_REDIRECT",
    auto_redirect: 5,
  },
  isDefault: false
};

export const useCheckoutCustomizationStore = create<ICheckoutCustomizationStore>()(
  devtools(
    (set) => ({
      customizationData: INITIAL_STATE,

      setCustomizationData: (updater) => set((state) => ({ 
        customizationData: typeof updater === 'function' ? updater(state.customizationData) : updater
      }),
        undefined,
        'CheckoutCustomizationStore/setCustomizationData'
      ),

      initialData: {
        customization_data: null,
        merchant_logo: null,
      },
      setInitialData: (initialData) => set(() => ({ initialData }),
        undefined,
        'CheckoutCustomizationStore/setInitialData'
      ),

      businessLogo: { path: null, file: null },
      setBusinessLogo: (businessLogo) => set(() => ({ businessLogo }),
        undefined,
        'CheckoutCustomizationStore/setBusinessLogo'
      ),

      isFetched: false,
      setIsFetched: (isFetched) => set(() => ({ isFetched }),
        undefined,
        'CheckoutCustomizationStore/setIsFetched'
      ),

      isLoading: false,
      setIsLoading: (isLoading) => set(() => ({ isLoading }),
        undefined,
        'CheckoutCustomizationStore/setIsLoading'
      ),
    
      isDataReset: 0,
      setIsDataReset: () => set((state) => ({ isDataReset: state.isDataReset + 1 }),
        undefined,
        'CheckoutCustomizationStore/setIsDataReset'
      ),

      errors: {},
      setErrors: (key, error) => set((state) => {
        const newErrors = { ...state.errors };
        if (error === '') {
          delete newErrors[key];
        } else {
          newErrors[key] = error;
        }
        return { errors: newErrors };
      },
        undefined,
        'CheckoutCustomizationStore/setErrors'
      ),

    } as ICheckoutCustomizationStore),
    { name: 'CheckoutCustomizationStore' }
  )
);